export default {
  content: [
    {
      meta: {
        id: 'I_vL9QJFhI',
        order: 0,
        component: 'CustomerHubVideo',
      },
      styles: { customClasses: '' },
      content: {
        mode: 'user',
        tagline: '',
        variant: 'variant2',
        videoUrl: '',
        posterUrl: '',
        logoHeight: '70',
        includeLogo: true,
        backgroundImageUrl:
          'https://demo-system-next.s3.eu-north-1.amazonaws.com/oxygen/upload/editor/imranidz-QXT4/home-cmp-ZsApxvKAi',
        backgroundVideoUrl: '',
      },
      componentId: 'cmp-0',
    },
    {
      meta: { component: 'Breadcrumb' },
      content: {
        link: 'home',
        text: '<p>Solutions / ${page.title}</p>',
      },
      componentId: 'cmp-1',
    },
    {
      meta: {
        layout: '',
        _columns: 1,
        component: 'Container',
        isFullWidth: false,
      },
      styles: { rowGap: '1rem', columnGap: '2rem' },
      content: [
        [
          {
            meta: { component: 'Title' },
            content: {
              level: '1',
              title: ' ${page.title}',
              pretitle: 'June 15, 2023',
              subtitle:
                '<p>Demo of RTCDP. Focused on profiles, audiences, governance policies, sources and destinations.</p>',
              alignment: 'center',
              textAlignment: 'center',
            },
            componentId: 'cmp-2-col_0-0',
          },
          {
            meta: {
              id: 'fEC8j_QONsojZayrJU-F_',
              layout: '',
              _columns: 1,
              component: 'Container',
              isFullWidth: false,
            },
            styles: { rowGap: '1rem', columnGap: '2rem' },
            content: [
              [
                {
                  meta: {
                    id: 'kGVkDsG_r1kvfcBjILEq0',
                    component: 'Video',
                  },
                  styles: { height: '600px' },
                  content: {
                    url: 'https://images-tv.adobe.com/mpcv3/5285/a9e3c719-eb95-4558-9f2b-3553c2a680f6_1621374012.854x480at800_h264.mp4',
                    mode: 'user',
                  },
                  componentId: 'cmp-2-col_0-1-col_0-0',
                },
                {
                  meta: {
                    id: 'SWirPVe-ReMY-XxjoY8so',
                    component: 'Iframe',
                  },
                  styles: {
                    width: '1080px',
                    height: '720px',
                    padding: '30px 0px 50px 0px',
                  },
                  content: {
                    url: 'https://view.adobe.com/viewer/656f896e8bd42cc9e3f2ccc5',
                  },
                },
                {
                  meta: {
                    id: 'QAUS5ud0_XRrbi_efaf4R',
                    component: 'Button',
                  },
                  styles: { padding: '20px 0px 50px 0px' },
                  content: {
                    link: 'external:https://view.adobe.com/viewer/656f896e8bd42cc9e3f2ccc5',
                    label: 'Slides used in this presentation',
                    variant: 'cta',
                    alignment: 'center',
                  },
                  componentId: 'cmp-2-col_0-1-col_0-2',
                },
              ],
            ],
          },
        ],
      ],
    },
  ],
}
